import React, { useEffect, useState } from "react";
import { useFilters } from "./FilterContext";
import SubCategory from "./SubCategory";
import axios from "axios";

const MainCategory = ({ main, isLast, isParent }) => {
  const { openMainCategories, toggleMainCategory, mappingRootRedirection } = useFilters();

  // const mappingRootRedirection = {
  //   "2326": "baby",
  //   "2328": "hh",
  //   "2330": "pet",
  //   "2329": "kids",
  // };

  // const [mappingRootRedirection, setmappingRootRedirection] = useState({})

  const APIURL = "https://admin.ourgreenhouse.com/"
    // const APIURL = "https://ourgreenhouse-staging-0d60dd13106b.herokuapp.com/" // Staging
  // const APIURL = "http://localhost:3001/";


  // const fetchCategories = async () => {
  //   try {
  //     const res = await axios.post(`${APIURL}api/BasketOption/`);
  //     const data = res.data.data || null

  //     if (data) {
  //       // Map API keys to your desired short keys
  //       const keyMapping = {
  //         babyCategoryId: "baby",
  //         himHerCategoryId: "hh",
  //         petsCategoryId: "pet",
  //         kidsCategoryId: "kids"
  //       };

  //       // Dynamically generate the mappingRootRedirection object
  //       const mappingRootRedirection = Object.fromEntries(
  //         Object.entries(keyMapping).map(([apiKey, shortKey]) => [data[apiKey], shortKey])
  //       );

  //       setmappingRootRedirection(mappingRootRedirection || {})
  //     } else {
  //       setmappingRootRedirection({})
  //     }
  //   } catch (err) {
  //     console.error('Error in fetched category', err);
  //   }
  // }

  // useEffect(() => {
  //   const initFetchCategories = async () => {
  //     await fetchCategories()
  //   }

  //   initFetchCategories()
  // }, [])

  const getRedirectionURL = (segment) => {
    switch (segment) {
      case "baby":
        return {
          "shop-by-item": "/baby-gifts/shop-by-item/by-size/shop-all-baby-items/",
          "baby-gift-baskets":
            "/baby-gifts/baby-gift-baskets/shop-all-baby-gift-baskets/",
        };
      case "hh":
        return {
          "shop-by-item": "/him-her-gifts/gift-baskets/by-occasion/shop-all-him-her-items/",
          "gift-baskets-for-him-&-her":
            "/him-her-gifts/gift-baskets/by-type/shop-all-gift-baskets/",
        };
      case "pet":
        return {
          "shop-by-item": "/pet-gifts/shop-by-item/shop-all-pet-items/",
          "dog-gift-baskets":
            "/pet-gifts/dog-gift-baskets/by-gender/shop-all/",
        };
      case "kids":
        return {
          "shop-by-item": "/kids-gifts/shop-by-item/by-age/shop-all-kids-items/",
          "kid's-gift-baskets":
            "/kids-gifts/kids-gift-baskets/by-gender/boy/shop-all-kids-baskets/",
        };
      default:
        break;
    }
  };

  // Function to get the value by key from an object
  function getValueByKey(obj, key) {
    // Check if the key exists in the object
    if (obj.hasOwnProperty(key)) {
      return obj[key]; // Return the value associated with the key
    } else {
      return null; // Return null if the key does not exist
    }
  }


  return (
    <div className={`main-category${isLast ? " last" : ""}`}>
      <h2
        onClick={(e) => {
          const parentCategoryID = document.getElementById("parent_level_cat")?.value;
          const categoryId = document.getElementById("category-id")?.value;

          // if (parentCategoryID) {
          if (main.openStatus == false) {
            if (Object.keys(mappingRootRedirection).length > 0) {
              if (parentCategoryID !== null && parentCategoryID !== "") {
                const joinedTitle = main.title.toLowerCase().replace(/\s+/g, "-")
                const redirectionURL = getRedirectionURL(
                  mappingRootRedirection[parentCategoryID || categoryId]
                );

                window.location.href = redirectionURL[joinedTitle];
              } else {
                const value = getValueByKey(mappingRootRedirection, categoryId);

                if (value) {
                  const joinedTitle = main.title.toLowerCase().replace(/\s+/g, "-")
                  const redirectionURL = getRedirectionURL(value);
                  window.location.href = redirectionURL[joinedTitle];
                }
              }
            }
          } else {
            toggleMainCategory(main.title);
          }
          // } else {
          //   toggleMainCategory(main.title);
          // }


          // const currentPath = localStorage.getItem("pathname");
          // const pathSegments = currentPath.split("/").filter(Boolean);
          // console.log(pathSegments, "pathSegments");
          // if (pathSegments.length > 1) {
          //   const firstLevelSegment = pathSegments[0] || "";
          //   const secondLevelSegment = pathSegments[1] || "";

          //   const mainLinkSegments = main.link.split("/").filter(Boolean);
          //   const mainLinkSecondLevelSegment = mainLinkSegments[1] || "";

          //   if (secondLevelSegment !== mainLinkSecondLevelSegment) {
          //     const redirectionURL = getRedirectionURL(
          //       mappingRootRedirection[firstLevelSegment]
          //     );
          //     window.location.href = redirectionURL[mainLinkSecondLevelSegment];
          //   } else {
          //     toggleMainCategory(main.title);
          //   }
          // } else {
          //   toggleMainCategory(main.title);
          // }
          // toggleMainCategory(main.title);
        }}
        style={{ cursor: "pointer" }}
      >
        {/* <a href={main.link} onClick={(e) => e.preventDefault()}> */}
        <a href={"#"} onClick={(e) => e.preventDefault()}>
          {main.title}
        </a>
        <span>
          {openMainCategories[main.title] ? (
            <svg
              width="14"
              height="2"
              viewBox="0 0 14 2"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M14 1.99805H0V-0.00195312H14V1.99805Z" fill="black" />
            </svg>
          ) : (
            <svg
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M14 7.99805H8V13.998H6V7.99805H0V5.99805H6V-0.00195312H8V5.99805H14V7.99805Z"
                fill="black"
              />
            </svg>
          )}
        </span>
      </h2>

      {openMainCategories[main.title] && (
        <div className="subcategory-list">
          {main.subcategories.map((sub, idx) => (
            <SubCategory key={`${sub.key}-${idx}`} sub={sub} />
          ))}
        </div>
      )}
    </div>
  );
};

export default MainCategory;
